export const getConfig = (accessToken: string) => ({ headers: { Authorization: `Bearer ${accessToken}` } })
